/*
 * Description of what this file is for
 *
 * @package  craft3
 * @author Stefan Prosch [hello@stefanprosch.com]
 * appHeader
 */

import hideOnScroll from 'hide-on-scroll';

const delay = ms => new Promise(_ => setTimeout(_, ms));
const bodyScrollLock = require('body-scroll-lock');

/* eslint-disable */
const disableBodyScroll = bodyScrollLock.disableBodyScroll;
const enableBodyScroll = bodyScrollLock.enableBodyScroll;
/* eslint-enable */

const appHeader = {
    cfg: {
        body: document.getElementsByTagName('body')[0],
        appHeader: document.querySelector('.js-appHeader'),
        mainNav: document.querySelector('.js-menu'),
        navWrapper: document.querySelector('.js-wrapper'),
        navBarToggle: document.querySelector('.js-navbarToggle')
    },

    init() {
        this.cfg.navBarToggle.addEventListener('click', () => {
            this.cfg.navWrapper.classList.toggle('active');
            this.cfg.navBarToggle.classList.toggle('active');

            if (this.cfg.navBarToggle.classList.contains('active')) {
                this.cfg.mainNav.classList.add('active');
                this.cfg.appHeader.classList.add('active');
                // this.cfg.body.style.overflow = 'hidden';
                this.cfg.body.classList.add('is-open--navigation');
                disableBodyScroll(this.cfg.navWrapper);
            } else {
                delay(700).then(() => this.cfg.mainNav.classList.remove('active'));
                delay(700).then(() => this.cfg.appHeader.classList.remove('active'));
                // this.cfg.body.style.overflow = '';
                this.cfg.body.classList.remove('is-open--navigation');
                enableBodyScroll(this.cfg.navWrapper);
            }
        });

        hideOnScroll({
            navbarSelector: '.js-appHeader',
            hidingClass: 'o-appHeader--isHidden',
            pollingInterval: 500
        });
    }
};

export default appHeader;



// WEBPACK FOOTER //
// ./___src/templates/_organisms/appHeader/_script.js